import { ConfigData } from '../config/StoreLocatorTextResources';

export class URLService {
  /**
   * https://developer.mozilla.org/en-US/docs/Web/API/Location
   */
  currentUrl: Location = document.location;
  urlSearchParams: URLSearchParams = new URLSearchParams(this.currentUrl.search);

  getlandingPageURL() {
    let url = ConfigData.data['urlLandingPage'];
    if (url === undefined) {
      url = '';
    }
    return url;
  }

  getOrderAtHomeURL() {
    let url = ConfigData.data['urlOrderAtHomePage'];
    if (url === undefined) {
      url = '';
    }
    return url;
  }

  deleteParams() {
    if (this.urlSearchParams) {
      const newUrl = `${window.location.pathname}`;
      window.history.replaceState({}, '', newUrl);
    }
  }

  updateParam(city) {
    if (this.urlSearchParams.has('s')) {
      const oldCity = this.urlSearchParams.get('s');

      if (oldCity.toLocaleLowerCase() !== city.toLocaleLowerCase()) {
        this.urlSearchParams.set('s', city);
        const newUrl = `${this.currentUrl.pathname}?${this.urlSearchParams.toString()}`;
        window.history.replaceState({}, '', newUrl);
      }
    }
  }

  redirectToLandingPage(cityName) {
    const newUrl = `${this.getlandingPageURL()}?s=${cityName}`;
    window.location.href = newUrl;
  }
}

export const URLSERVICE = new URLService();
